(function(){
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cleanSwiperNode(node) {
    if (!node || !node.classList) return;
    var toRemove = [];
    for (var i = 0; i < node.classList.length; i++) {
      var name = node.classList[i];
      if (name && name.indexOf('swiper-') === 0 && name !== 'swiper') toRemove.push(name);
    }
    toRemove.forEach(function(name) { node.classList.remove(name); });
  }

  function destroyOtherSwipersInSection(section, excludeContainer) {
    var containers = section.querySelectorAll('[data-sctswiper="true"]');
    containers.forEach(function(c) {
      if (c === excludeContainer) return;
      var node = c.querySelector('.sct-swiper');
      if (node && node.sctSwiper) {
        try {
          node.sctSwiper.destroy(true, true);
          node.sctSwiper = null;
          cleanSwiperNode(node);
        } catch(e) {}
      }
    });
  }

  function initSCTSwiper(shouldAnimate) {
    shouldAnimate = shouldAnimate === true;

    if (typeof Swiper === 'undefined') return;

    var containers = document.querySelectorAll('[data-sctswiper="true"]');
    if (!containers.length) return;

    containers.forEach(function(container){
      var panel = container.closest('.sct__panel');
      if (!panel) return;

      var shouldShowSwiper = panel.classList.contains('sct__panel--carousel');

      if (!shouldShowSwiper) {
        var existingNode = container.querySelector('.sct-swiper');
        if (existingNode && existingNode.sctSwiper) {
          try {
            existingNode.sctSwiper.destroy(true, true);
            existingNode.sctSwiper = null;
            cleanSwiperNode(existingNode);
          } catch(e) {}
        }
        return;
      }

      if (panel.hidden) return;

      var node = container.querySelector('.sct-swiper');
      if (!node) return;

      var section = container.closest('section.sct');
      var navInHeader = section && section.classList.contains('sct-nav-in-header');
      if (navInHeader) {
        destroyOtherSwipersInSection(section, container);
      }

      if (node.sctSwiper) {
        try {
          node.sctSwiper.destroy(true, true);
          node.sctSwiper = null;
          cleanSwiperNode(node);
        } catch(e) {}
      }

      try {
        var optsAttr = container.getAttribute('data-options');
        var base = {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: prefersReducedMotion ? 0 : 300,
          breakpoints: {}
        };
        var extra = {};
        if (optsAttr) {
          try { extra = JSON.parse(optsAttr); } catch(e) {}
        }

        var style = getComputedStyle(container);
        var gapMobile = parseInt(style.getPropertyValue('--sct-slider-gap-mobile'), 10) || 16;
        var gapTablet = parseInt(style.getPropertyValue('--sct-slider-gap-tablet'), 10) || 16;
        var gapDesktop = parseInt(style.getPropertyValue('--sct-slider-gap-desktop'), 10) || 16;
        var spm = parseFloat(style.getPropertyValue('--sct-slides-mobile')) || 1;
        var spt = parseFloat(style.getPropertyValue('--sct-slides-tablet')) || 2;
        var spd = parseFloat(style.getPropertyValue('--sct-slides-desktop')) || 4;

        if (spm < 0.1) spm = 1;
        if (spt < 0.1) spt = 2;
        if (spd < 0.1) spd = 4;
        if (gapMobile < 0) gapMobile = 0;
        if (gapTablet < 0) gapTablet = 0;
        if (gapDesktop < 0) gapDesktop = 0;

        /* Stage padding: allineato a new-home-collection-swiper / new-home-media-slider — slidesOffsetAfter = padding-left slider (20px mobile / 35px desktop) solo se "Rimuovi padding destro" è attivo. */
        var hasMobileRightPaddingRemoved = section && section.getAttribute('data-remove-right-padding-mobile') === 'true';
        var hasDesktopRightPaddingRemoved = section && section.getAttribute('data-remove-right-padding-desktop') === 'true';
        var offsetAfterMobile = hasMobileRightPaddingRemoved ? 20 : 0;
        var offsetAfterDesktop = hasDesktopRightPaddingRemoved ? 35 : 0;

        base.spaceBetween = gapMobile;
        base.slidesPerView = spm;
        base.slidesOffsetAfter = offsetAfterMobile;
        base.breakpoints = {
          768: { slidesPerView: spt, spaceBetween: gapTablet, slidesOffsetAfter: offsetAfterDesktop },
          992: { slidesPerView: spd, spaceBetween: gapDesktop, slidesOffsetAfter: offsetAfterDesktop }
        };

        if (prefersReducedMotion && extra.autoplay) {
          extra.autoplay = false;
        }

        var wrapper = node.querySelector('.swiper-wrapper');
        var slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        var realSlideCount = slides.length;

        var paginationEl = container.querySelector('.swiper-pagination');
        if (extra.pagination && paginationEl) {
          base.pagination = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active'
          };
        }

        if (section && typeof extra.hide_arrows_mobile === 'boolean') {
          if (extra.hide_arrows_mobile === true) {
            section.setAttribute('data-hide-arrows-mobile', 'true');
            section.classList.add('sct-hide-arrows-mobile');
          } else {
            section.removeAttribute('data-hide-arrows-mobile');
            section.classList.remove('sct-hide-arrows-mobile');
          }
        }
        var hideArrowsMobile = section && section.getAttribute('data-hide-arrows-mobile') === 'true';
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var useNavigation = extra.navigation && (!hideArrowsMobile || !isMobile);

        var nextEl = container.querySelector('.swiper-button-next') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-next'));
        var prevEl = container.querySelector('.swiper-button-prev') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-prev'));

        if (useNavigation && nextEl && prevEl) {
          base.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
            disabledClass: 'swiper-button-disabled'
          };
        }

        if (extra.loop) {
          base.loop = true;
          if (realSlideCount > 0) base.loopedSlides = realSlideCount;
        }
        if (extra.autoplay) base.autoplay = extra.autoplay;

        var swiper = new Swiper(node, base);
        node.sctSwiper = swiper;

        if (section && section.classList.contains('sct-nav-in-header') && useNavigation) {
          var headerNext = section.querySelector('.section-header-tokens__nav .swiper-button-next');
          var headerPrev = section.querySelector('.section-header-tokens__nav .swiper-button-prev');
          if (headerNext && headerPrev && (headerNext !== nextEl || headerPrev !== prevEl)) {
            headerNext.addEventListener('click', function() { swiper.slideNext(); });
            headerPrev.addEventListener('click', function() { swiper.slidePrev(); });
            function syncHeaderDisabled() {
              headerPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
              headerNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
            }
            syncHeaderDisabled();
            swiper.on('slideChangeTransitionEnd', syncHeaderDisabled);
            swiper.on('init', syncHeaderDisabled);
          }
        }

        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode && section) {
          var sectionId = String(section.id.replace('sct-', ''));
          document.addEventListener('shopify:section:unload', function unloadHandler(e) {
            var unloadedId = e.detail && e.detail.sectionId != null ? String(e.detail.sectionId) : '';
            if (unloadedId === sectionId) {
              if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
                node.sctSwiper = null;
                cleanSwiperNode(node);
              }
              document.removeEventListener('shopify:section:unload', unloadHandler);
            }
          });
        }
      } catch(e) {
        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
          console.error('[SCT] Errore init Swiper', e);
        }
      }
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      requestAnimationFrame(function() {
        requestAnimationFrame(initSCTSwiper);
      });
    }, 300);
  });

  function waitForSwiper(callback, maxAttempts) {
    maxAttempts = maxAttempts || 50;
    var attempts = 0;
    function check() {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 100);
      }
    }
    check();
  }

  function runInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        initSCTSwiper();
      });
    } else {
      initSCTSwiper();
    }
  }

  waitForSwiper(runInit);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
        var panel = mutation.target;
        if (!panel.hidden && panel.classList.contains('sct__panel--carousel') && panel.querySelector('[data-sctswiper="true"]')) {
          setTimeout(function() { initSCTSwiper(true); }, 150);
        }
      }
    });
  });

  function setupObserver() {
    document.querySelectorAll('.sct__panel').forEach(function(panel) {
      observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initSCTSwiper();
      setupObserver();
    });
    document.addEventListener('shopify:section:unload', function(e) {
      var sectionEl = e.target && e.target.nodeType === 1 ? e.target : (e.detail && e.detail.sectionId ? document.getElementById('sct-' + e.detail.sectionId) : null);
      var containers = sectionEl && sectionEl.querySelectorAll ? sectionEl.querySelectorAll('[data-sctswiper="true"]') : [];
      containers.forEach(function(container) {
        var node = container.querySelector('.sct-swiper');
        if (node && node.sctSwiper) {
          try {
            node.sctSwiper.destroy(true, true);
            node.sctSwiper = null;
            cleanSwiperNode(node);
          } catch(err) {}
        }
      });
    });
  }
})();
